import { useState } from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Field } from "../components/Shared";
import { useAuth } from "../context/AuthContext";
import { formatApiError } from "../lib/api";
import { AuthShell } from "./Login";

const FIELDS = [
  ["company_name", "Nom de l'entreprise de déménagement", "text", true],
  ["siret", "SIRET / n° TVA intracom. (optionnel)", "text", false],
  ["fleet_size", "Taille de flotte (ex : 3 camions)", "text", false],
  ["name", "Votre nom", "text", true],
  ["email", "E-mail professionnel", "email", true],
  ["password", "Mot de passe (8 caractères min.)", "password", true],
];

export default function Register() {
  const { user, register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ company_name: "", siret: "", fleet_size: "", name: "", email: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to="/app" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await register(form);
      navigate("/app");
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell title="Créer votre compte entreprise" subtitle="Un espace dédié et isolé pour votre société.">
      <form onSubmit={submit} className="grid gap-4 sm:grid-cols-2" data-testid="register-form">
        {FIELDS.map(([key, label, type, required]) => (
          <div key={key} className={key === "company_name" || key === "email" || key === "password" ? "sm:col-span-2" : ""}>
            <Field label={label}>
              <Input data-testid={`register-${key}-input`} type={type} required={required} minLength={key === "password" ? 8 : undefined}
                value={form[key]} onChange={(e) => setForm({ ...form, [key]: e.target.value })} />
            </Field>
          </div>
        ))}
        {error && <p className="text-sm text-red-600 sm:col-span-2" data-testid="register-error">{error}</p>}
        <Button type="submit" disabled={loading} className="rounded-full bg-[#0b2c6b] hover:bg-[#1559d6] sm:col-span-2" data-testid="register-submit-button">
          {loading && <Loader2 className="mr-2 h-4 w-4 animate-spin" />} Créer mon espace
        </Button>
        <p className="text-center text-sm text-slate-500 sm:col-span-2">
          Déjà inscrit ? <Link to="/login" className="font-semibold text-[#1559d6]" data-testid="go-login-link">Se connecter</Link>
        </p>
      </form>
    </AuthShell>
  );
}
